import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import CustomerLayout from "../Layouts/CustomerLayout";
import { currentUserRolesArr, getShenlongQueryParams, isDesktopApp } from "../constants/AppMethod";
import { ValidateRoles } from "../constants/UserRoles";
import { nativeAppRoutePaths } from "../constants/Routes";


const NativeAppCustomerProtectedRoute = ({ component: Component,  ...rest }) => {
    const { instance } = useMsal();
    const accounts = instance.getAllAccounts();
    const isAuthenticated = (accounts.length > 0) ? true : false;
    const currentUserRoles = currentUserRolesArr();
    const isCustomerRole = ValidateRoles(currentUserRoles).isCustomer;
    const isDesktopNativeApp = isDesktopApp();
    const {isOnlyAuth} = getShenlongQueryParams() || {};
    let skipRoleValidation = (isDesktopNativeApp && isOnlyAuth) ? true : false
   
    return (
        <Route {...rest} render={props => {
            const data = {"path": props.location.pathname, "isSubscribed": rest.isSubscribed};
            if(!rest.dontTrack){
                sessionStorage.setItem('USER_PATH_HISTORY', JSON.stringify(data));
            }
            if (!isAuthenticated) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: nativeAppRoutePaths.LOGIN_PAGE_URL, state: { from: props.location } }} />
            }
            if(!isCustomerRole && !skipRoleValidation){
                return <Redirect to={{ pathname: nativeAppRoutePaths.LOGIN_PAGE_URL, state: { from: props.location } }} />
            }
            // authorised so return component
            return(
                <CustomerLayout isSubscribed={rest.isSubscribed}>
                    <Component {...props} />
                </CustomerLayout>
            )
        }} />
    )
}

export default NativeAppCustomerProtectedRoute;